export default __webpack_public_path__ + "static/compound-arc-770374649fc71ef184365ad0aeb2a946.png";